import type { OccurrenceResponseStatus } from '@kidshome/api-contract';

/**
 * Shared agenda presentation model for the weekly calendar (kid + household views). Centralizes the
 * status→dot tone map and the KIND day-counting both surfaces use, so the two personas stay consistent.
 */

/** Dot tone per occurrence status (mirrors StatePill semantics). */
export const DOT_TONE: Record<OccurrenceResponseStatus, string> = {
  approved: 'bg-success',
  skipped: 'bg-success',
  pending_approval: 'bg-warning',
  planned: 'bg-surface-muted',
  rejected: 'bg-warning',
  missed: 'bg-surface-muted',
};

export function isDone(status: OccurrenceResponseStatus): boolean {
  return status === 'approved' || status === 'skipped';
}

export interface DayCounts {
  done: number;
  waiting: number;
  left: number;
}

/**
 * Count a day's occurrences with KIND framing (children's product, no shaming): a `pending_approval`
 * chore reads as "waiting" — the kid already did the work, so it must NEVER count as "left". A past
 * day's `missed` chore is excluded from "left" too: it isn't actionable anymore, and a perpetual
 * "1 left" on yesterday reads as a reproach.
 */
export function countStatuses(statuses: readonly OccurrenceResponseStatus[]): DayCounts {
  let done = 0;
  let waiting = 0;
  let left = 0;
  for (const s of statuses) {
    if (s === 'approved' || s === 'skipped') done += 1;
    else if (s === 'pending_approval') waiting += 1;
    else if (s !== 'missed') left += 1;
  }
  return { done, waiting, left };
}
